export const classes = {
  paper: 'rounded-2xl',
  body: 'px-8',
};
